import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpacesBySlugsKey } from '../../utils/keys';
import { useCachedSpaces } from '../cache/useCachedSpace';
export const useSpacesBySlugs = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const cachedSpaces = useCachedSpaces(variables.slugs.map(slug => ({ slug })));
    const spacesBySlugsKey = getSpacesBySlugsKey(variables);
    return useQuery(spacesBySlugsKey, () => client === null || client === void 0 ? void 0 : client.spaces.listBySlugs(variables, fields), { placeholderData: () => cachedSpaces, ...useQueryOptions });
};
//# sourceMappingURL=useSpacesBySlugs.js.map